export const quantityIncrementor = async (
  quantity,
  variantId,
  lineId,
  min = 0,
  step = 1,
) => {
  const id = `quantity_${crypto.randomUUID()}`

  return `
    <div class="mini-cart-item__info-quantity">
      <div
        class="quantity-incrementor"
        data-variant-id="${variantId}"
        data-line-id="${lineId}"
      >
        <label for="${id}" class="quantity-incrementor__label screenreader-text">
          ${window.theme.strings.quantity}:
        </label>

        <button class="quantity-incrementor__minus" type="button">
          <span class="screenreader-text">
            ${window.theme.strings.incrementorMinus}
          </span>
        </button>

        <input
          class="quantity-incrementor__input"
          type="number"
          id="${id}"
          name="quantity"
          value="${quantity}"
          min="${min}"
          step="${step}"
          max="${window.theme.inventory[variantId] || 999}"
          aria-label="${window.theme.strings.itemQuantity}"
        />

        <button class="quantity-incrementor__plus" type="button">
          <span class="screenreader-text">
            ${window.theme.strings.incrementorPlus}
          </span>
        </button>
      </div>
    </div>
  `
}

export const cartEmptyState = async () => `
  <div class="cart__empty">

  </div>
`

export const minicartEmptyState = async () => `
  <div class="mini-cart__empty">
    <h2 class="mini-cart__empty-title">${window.theme.strings.miniCart.empty.title}</h2>
    <p class="mini-cart__empty-text">${window.theme.strings.miniCart.empty.content}</p>

    <a href="/products/all" class="text-link">
      ${window.theme.strings.miniCart.empty.buttonText}
    </a>
  </div>
`
